export class ListaPrecio {
    public codListaPrecio: number;
    public codListaPrecioErp: string;
    public descripcion: string;
    public codEmpresa: number;
    public ecommerce: boolean;
    constructor() {
    }
}
